import { SamplesBudgetApiClient } from '@fourthwall/services/dist/SamplesBudgetApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSamplesBudgetBalanceQuery = createQueryHook(SamplesBudgetApiClient.getBalance, {
  queryKey: ['samplesBudgetBalance'],
})
